import { CHART_TYPE_CHOICES } from '../../editors/jepto-chart-editor/chart-tab/chart-type-choices';

export type ReportCardAudience = 'editor' | 'viewer';
export type CardQueryStatusKind = 'empty' | 'error';
export type CardQueryStatusNoun = 'chart' | 'table';

export interface CardQueryStatusCopy {
	title: string;
	subtitle: string;
}

export function cardQueryStatusCopy(
	audience: ReportCardAudience,
	kind: CardQueryStatusKind,
	noun: CardQueryStatusNoun
): CardQueryStatusCopy {
	if (kind === 'empty') {
		if (audience === 'editor') {
			return {
				title: 'No data for this date range',
				subtitle:
					'Try adjusting your date range or check your data source connection.',
			};
		}
		return {
			title: 'No data available',
			subtitle: "There's no data to display for this date range.",
		};
	}

	if (audience === 'editor') {
		return {
			title: `Couldn't load ${noun} data`,
			subtitle: 'Check your data source connection and refresh.',
		};
	}

	return {
		title: `This ${noun} isn't loading right now`,
		subtitle:
			'Try refreshing. If the problem continues, contact the report owner.',
	};
}

export function cardQueryStatusEmptyIcon(
	chartType?: string,
	noun: CardQueryStatusNoun = 'chart'
): string {
	if (noun === 'table') {
		return 'table_chart';
	}
	const normalized = chartType?.trim().toLowerCase();
	const match = CHART_TYPE_CHOICES.find(choice => choice.value === normalized);
	return match?.icon ?? 'bar_chart';
}
